import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from "../../services/users.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Router, ActivatedRoute } from "@angular/router";
import { jsPDF } from "jspdf";
import { DatePipe } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-completed-details',
  templateUrl: './completed-details.component.html',
  styleUrls: ['./completed-details.component.scss'],
  providers: [DatePipe]
})
export class CompletedDetailsComponent implements OnInit {

  showDetails: boolean = false;
  panelOpenState = false;
  activeTab = 0;
  showDetailsEvent() { this.showDetails = !this.showDetails; }
  myFont: any; assignDetailResumeUserCourse: any = [];
  closeResult = ''; userLoginData: any = []; courseId: any = ''; assignDetailResume: any = []; assignDetailResumePro: any = []; myDate = new Date(); currentData: any = ''; currentBaseUrl: any = '';
  constructor(private router: Router, private authUser: UsersService, private route: ActivatedRoute, private spinner: NgxSpinnerService,
    private modalService: NgbModal, private datePipe: DatePipe) {
    if (localStorage.getItem('userLoginData') == '' || localStorage.getItem('userLoginData') == null) {
      this.router.navigateByUrl('/');
    }
    this.currentData = this.datePipe.transform(this.myDate, 'dd/MM/yyyy');
  }
  open1(content: any) { 
    this.modalService.open(content, { centered: true, size: 'sm', backdrop: 'static', keyboard: false }); 
  }
  ngOnInit(): void {
    this.currentBaseUrl = environment.BASEURL;
   // this.currentBaseUrl ='http://localhost:4200/';
    this.userLoginData = JSON.parse(localStorage.getItem('userLoginData') || '[]');
    this.route.queryParams.subscribe(queryParams => {
      this.courseId = queryParams['courseId'];
    });
    if ((this.userLoginData != '' || this.userLoginData != null) && (this.courseId != '' || this.courseId != null)) {
      this.assignCourseDetail(this.userLoginData.user_id);
    }
  }
  /*****second convert into hr min and sec */
  secondsToHms(d: any) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);
    return h + ' hr ' + m + ' min';
  }
  /*getting course detail of selected course*/
  assignCourseDetail(userId: any) {
    this.authUser.assignCourseDetails(userId, this.courseId).subscribe(
      data => {
        if(data.status == 401){
          document.getElementById('successMsg')?.click();
        }else{
          this.assignDetailResume = data.data;
          this.assignDetailResumePro = data.data.user_course_progress;
          this.assignDetailResumeUserCourse = data.data.userCourse[0];
        }
      }, error => {
      }
    )
  }
  toTitleCase(str:any) {
    return str
      .toLowerCase()
      .split(" ")
      .map((word:any) => word[0].toUpperCase() + word.slice(1))
      .join(" ");
  }
  /****download cartificate for completed course start  */
  downloadCartiCourse(course_name: any,completed_date:any) {
    const fullName = this.toTitleCase((this.userLoginData.first_name + " " + this.userLoginData.last_name).toLowerCase());
    this.currentData = this.datePipe.transform(completed_date, 'dd/MM/yyyy');
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: "px",
      format: [550, 297],
    });
    // const doc= new jsPDF('p', 'mm', 'a4');
    var width = doc.internal.pageSize.getWidth();
    doc.setDrawColor(35, 36, 115); // draw red lines
    // TOP
    doc.setLineWidth(10);
    doc.line(0, 0, 600, 0);
    // Bottom
    doc.setLineWidth(5);
    doc.line(0, 295, 600, 295);
    //LEFT
    doc.setLineWidth(10);
    doc.line(0, 600, 0, 0);
    //RIGHT 
    doc.setLineWidth(10);
    doc.line(550, 500, 550, 0);
    doc.addImage('../../../assets/images/logo.png', 'PNG', 460, 20, 70, 15);
    doc.addImage('../../../assets/images/vandhanalogo.jpeg', 'JPEG',  15, 5, 80, 50);
    doc.addFont('../../../assets/font/itcedscr-webfont.ttf', 'edwardian_script_itcregular', 'normal');
    doc.setFont('edwardian_script_itcregular');
    doc.setFontSize(50);
    doc.setTextColor(67, 67, 67);
    doc.text("Certificate of Course Completion", width / 2, 90, { align: 'center' });
    if(fullName.length < 50){
      doc.setFontSize(25);
      doc.setTextColor(67, 67, 67);
      doc.text("This is to Certify that " +`" `  + fullName + `"`+ " has successfully completed", width / 2, 123, { align: 'center' });
      if(course_name.length < 50){
        doc.setLineWidth(0.5);
        // doc.line(270, 132, 210, 132);
        doc.setFontSize(27);
        doc.setTextColor(67, 67, 67);
        doc.text(`" ` + course_name + `" `+ " on " + this.currentData + "", width / 2, 155, { align: 'center' });
        doc.addImage('../../../assets/images/ashish_sign.png', 'PNG', 65, 205, 60, 18);
        doc.setFont('normal');
        doc.setLineWidth(0.5);
        doc.line(50, 225, 140, 225);
        doc.setFontSize(12);
        doc.setTextColor(35, 66, 125);
        doc.text("Ashish Agarwal", 63, 235);
        doc.text("Sr. Training Manager", 57, 250);
        doc.addImage('../../../assets/images/bage.png', 'PNG', 260, 185, 52, 70);
        doc.addImage('../../../assets/images/divakarSign.png', 'PNG', 420, 205, 65, 20);
        doc.setFont('normal');
        doc.setLineWidth(0.5);
        doc.line(498, 225, 415, 225);
        doc.setFontSize(12);
        doc.setTextColor(35, 66, 125);
        doc.text("Diwakar Dubey", 425, 235);
        doc.text("Training Manager", 420, 250);
      }else{
        doc.setLineWidth(0.5);
        // doc.line(270, 132, 210, 132);
        doc.setFontSize(27);
        doc.setTextColor(67, 67, 67);
        doc.text(`" ` + course_name + `" `, width / 2, 155, { align: 'center' });
        doc.setFontSize(27);
        doc.setTextColor(67, 67, 67);
        doc.text(" on " + this.currentData + "", width / 2, 180, { align: 'center' });
        doc.addImage('../../../assets/images/ashish_sign.png', 'PNG', 65, 225, 60, 18);
        doc.setFont('normal');
        doc.setLineWidth(0.5);
        doc.line(50, 245, 140, 245);
        doc.setFontSize(12);
        doc.setTextColor(35, 66, 145);
        doc.text("Ashish Agarwal", 63, 255);
        doc.text("Sr. Training Manager", 57, 270);
        doc.addImage('../../../assets/images/bage.png', 'PNG', 260, 205, 52, 70);
        doc.addImage('../../../assets/images/divakarSign.png', 'PNG', 420, 225, 65, 20);
        doc.setFont('normal');
        doc.setLineWidth(0.5);
        doc.line(498, 245, 415, 245);
        doc.setFontSize(12);
        doc.setTextColor(35, 66, 145);
        doc.text("Diwakar Dubey", 425, 255);
        doc.text("Training Manager", 420, 270);
      }
    }else{
      doc.setFontSize(25);
      doc.setTextColor(67, 67, 67);
      doc.text("This is to Certify that " +`" `  + fullName + `"`, width / 2, 123, { align: 'center' });
      doc.setFontSize(25);
      doc.setTextColor(67, 67, 67);
      doc.text(" has successfully completed", width / 2, 143, { align: 'center' });
      if(course_name.length < 50){
        doc.setLineWidth(0.5);
        // doc.line(270, 132, 230, 132);
        doc.setFontSize(27);
        doc.setTextColor(67, 67, 67);
        doc.text(`" ` + course_name + `" `+ " on " + this.currentData + "", width / 2, 175, { align: 'center' });
        doc.addImage('../../../assets/images/ashish_sign.png', 'PNG', 65, 225, 60, 18);
        doc.setFont('normal');
        doc.setLineWidth(0.5);
        doc.line(50, 245, 140, 245);
        doc.setFontSize(12);
        doc.setTextColor(35, 66, 145);
        doc.text("Ashish Agarwal", 63, 255);
        doc.text("Sr. Training Manager", 57, 270);
        doc.addImage('../../../assets/images/bage.png', 'PNG', 260, 205, 52, 70);
        doc.addImage('../../../assets/images/divakarSign.png', 'PNG', 420, 225, 65, 20);
        doc.setFont('normal');
        doc.setLineWidth(0.5);
        doc.line(498, 245, 415, 245);
        doc.setFontSize(12);
        doc.setTextColor(35, 66, 145);
        doc.text("Diwakar Dubey", 425, 255);
        doc.text("Training Manager", 420, 270);
      }else{
        doc.setLineWidth(0.5);
        // doc.line(270, 132, 210, 132);
        doc.setFontSize(27);
        doc.setTextColor(67, 67, 67);
        doc.text(`" ` + course_name + `" `, width / 2, 175, { align: 'center' });
        doc.setFontSize(27);
        doc.setTextColor(67, 67, 67);
        doc.text(" on " + this.currentData + "", width / 2, 195, { align: 'center' });
        doc.addImage('../../../assets/images/ashish_sign.png', 'PNG', 65, 240, 60, 18);
        doc.setFont('normal');
        doc.setLineWidth(0.5);
        doc.line(50, 260, 140, 260);
        doc.setFontSize(12);
        doc.setTextColor(35, 66, 160);
        doc.text("Ashish Agarwal", 63, 270);
        doc.text("Sr. Training Manager", 57, 285);
        doc.addImage('../../../assets/images/bage.png', 'PNG', 260, 220, 52, 70);
        doc.addImage('../../../assets/images/divakarSign.png', 'PNG', 420, 240, 65, 20);
        doc.setFont('normal');
        doc.setLineWidth(0.5);
        doc.line(498, 260, 415, 260);
        doc.setFontSize(12);
        doc.setTextColor(35, 66, 160);
        doc.text("Diwakar Dubey", 425, 270);
        doc.text("Training Manager", 420, 285);
      }
    }
  
    doc.save(course_name +"_certificate.pdf");
    //this.router.navigate(['/completed']);

  }
  /****download cartificate for completed course end  */
  navigationEvent() {
    localStorage.removeItem('userLoginData');
    this.router.navigateByUrl('/'); 
    
  }

}
